import Homepage from './pages/Homepage.vue'
import Solution from './pages/Solution.vue'
import ProductAndService from './pages/ProductAndService.vue'
import About from './pages/About.vue'
import Phbo from './pages/ProductAndService/Phbo.vue'
import HMOC from './pages/ProductAndService/HMOC.vue'
import DataService from './pages/ProductAndService/DataService.vue'
import MOBEC from './pages/ProductAndService/MOBEC.vue'
import Case from './pages/Solution/Case.vue'
import HugeData from './pages/Solution/HugeData.vue'
import LCStudies from './pages/Solution/LCStudies.vue'
import CHMAS from './pages/Solution/CHMAS.vue'
import NotFoundComponent from './pages/NotFoundComponent.vue'
import Report from './pages/Report.vue'

export default[
    {
      path:'*',
      component: NotFoundComponent
    },
    {
      path: '/',
      component:Homepage
    },
    {
      path: '/Solution',
      component: Solution,
      children:[
        {
          path:'Case',
          component:Case
        },
        {
          path:'HugeData',
          component:HugeData
        },
        {
          path:'LCStudies',
          component:LCStudies
        },
        {
          path:'CHMAS',
          component:CHMAS
        }
      ]
    },
    {
      path: '/ProductAndService',
      component:ProductAndService,
      children:[
        {
          path:'Phbo',
          component:Phbo
        },
        {
          path:'HMOC',
          component:HMOC
        },
        {
          path:'DataService',
          component:DataService
        },
        {
          path:'MOBEC',
          component:MOBEC
        }
      ]
    },
    {
      path: '/About',
      component:About
    },
    {
      path: '/Report',
      component:Report
    }
  ]



// WEBPACK FOOTER //
// ./src/navroutes.js